import style from './Mask.style';

export default function Mask({ active }) {
  return (
    <div css={ style } data-active={ active } />
  );
};